module.exports = __webpack_public_path__ + "static/img/zulki-jrzt.42d6cdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unsplash/zulki-jrzt.jpg
// module id = Rkjk
// module chunks = 0